export default __webpack_public_path__ + "static/media/_olympics.45b7aeb4.ico";